<template>
  <section class="how-it-works-section">
    <div class="container">
      <div class="left-column">
        <h1 class="left-column-title">How it works</h1>
        <p class="left-column-description">
          Four simple steps. For a brighter future.
        </p>
        <ApplyButton
          cta-section="how-it-works"
          page-name="role-page"
          class="proxify-btn proxify-btn-white"
        />
      </div>
      <div class="right-column">
        <div class="items">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="item"
          >
            <NuxtImg
              class="item-icon"
              :src="item.icon"
              alt="item"
            />
            <NuxtImg
              v-if="index === 0"
              class="line"
              alt="line"
              src="/images/roles/how-it-works/line.svg"
            />
            <NuxtImg
              v-if="[1, 2].includes(index)"
              class="line"
              alt="line"
              src="/images/roles/how-it-works/dotted_line.svg"
            />
            <div class="content">
              <h2>{{ item.title }}</h2>
              <p>{{ item.description }}</p>

              <ApplyButton
                cta-section="how-it-works"
                page-name="role-page"
                class="proxify-btn proxify-btn-white"
              />
            </div>
          </div>
        </div>

        <ApplyButton
          cta-section="how-it-works"
          page-name="role-page"
          class="proxify-btn proxify-btn-white"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: {
    ApplyButton,
  },
  data() {
    return {
      items: [
        {
          title: 'Apply to join',
          description:
            'Hit “apply to join” to complete your online application, it only takes a few minutes.',
          icon: '/images/roles/how-it-works/apply_now.svg',
        },
        {
          title: 'Take test and interview',
          description:
            'If your application is progressed, you’ll be invited to a remote technical test and interview with our friendly team.',
          icon: '/images/roles/how-it-works/vetting_process.svg',
        },
        {
          title: 'Become a member',
          description:
            'Congrats, you passed! You’ll gain members-only access to job openings, webinars and certified coaching to help supercharge your career.',
          icon: '/images/roles/how-it-works/join_our_network.svg',
        },
        {
          title: 'Apply to jobs',
          description:
            'We’ll recommend you for jobs that match your ambitions with clients who already know about your talents as a Proxify member.',
          icon: '/images/roles/how-it-works/get_access.svg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" src="./HowItWorksSection.scss" scoped />
